import { createAction } from '@fb/redux'

export const inc = createAction('inc')<string>()
export const dec = createAction('dec')<string>()
